export function parseBalanceFromUrl() {
  if (typeof window === 'undefined') return 0

  const searchParams = new URLSearchParams(window.location.search)
  let raw = searchParams.get('balance')

  if (!raw) {
    const match = window.location.href.match(/[?&]balance=([^&#]+)/)
    raw = match?.[1] ?? null
  }

  if (!raw) return 0

  const parsed = Number.parseFloat(decodeURIComponent(raw).replace(',', '.'))
  return Number.isFinite(parsed) ? parsed : 0
}

export function formatBalance(value) {
  return value.toLocaleString('ru-RU', {
    minimumFractionDigits: 2,
    maximumFractionDigits: 2,
  })
}
